<ng-container *transloco="let t">
  @if ((events?.length ?? 0) > 0) {
    <div class="table-responsive">
      <table class="table dark-header table-last-row-no-border">
        <thead>
          <tr>
            <th class="expand-column-width"></th>
            <th class="id-column-width">{{ t('event.item.id') }}</th>
            <th class="name-column-width">{{ t('app.common.item.name') }}</th>
            <th class="name-column-width">{{ t('event.item.short.name') }}</th>
            @if (showOrganizerName) {
                <th class="organizer-column-width">{{ t('app.common.organizer') }}</th>
            }
            @if (showRound) {
                <th class="round-column-width text-center center-align">{{ t('event.item.round') }}</th>
            }
            @if (showType) {
                <th class="status-column-width text-center">{{ t('league.details.event.type') }}</th>
            }
            <th class="status-column-width text-center">{{ t('event.item.status') }}</th>
            <th class="date-column-width text-end center-align">{{ t('event.item.start.date') }}</th>
            <th class="date-column-width text-end center-align">{{ t('event.item.end.date') }}</th>
            <th class="more-column-width"></th>
          </tr>
        </thead>
        <tr app-table-header-separator></tr>
        <tbody>
          @for (eventItem of events; track eventItem) {
            <tr class="expandable-row" (click)="toggleEvent(eventItem!.id!)">
              <td class="center-align">
                @if (showRaces) {
                  <i class="bi" [ngClass]="expandedEventIds.has(eventItem!.id!) ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                }
              </td>
              <td class="center-align">{{ eventItem.id }}</td>
              <td class="center-align text-wrap fw-600">
                <app-language-output
                    [hrLabel]="eventItem.name"
                    [enLabel]="eventItem.nameEng"
                    [itLabel]="eventItem.nameIta"
                    [srLabel]="eventItem.nameSr"
                    [bsLabel]="eventItem.nameBs"
                    [siLabel]="eventItem.nameSlo"
                    [defaultLanguage]="eventItem?.defaultLanguage"
                    [languages]="languages"/>
              </td>
              <td class="center-align">
                    <app-language-output [multiLangValue]="eventItem?.nameShort"
                                         [languages]="languages"
                    />
              </td>
              @if (showOrganizerName) {
                <td class="center-align">{{ eventItem.organiser?.name }}</td>
              }
              @if (showRound) {
                <td class="text-center center-align">{{ eventItem.round ?? "-" }}</td>
              }
              @if (showType) {
                <td class="center-align text-center">
                  <div class="status-badge" [ngClass]="eventItem.leagueEventType != null ? typeClassMap[eventItem.leagueEventType] : ''">
                    <span class="fw-bold">
                      {{ (eventItem.leagueEventType ? t('league.details.event.type.' + eventItem.leagueEventType) : "-") | uppercase}}
                    </span>
                  </div>
                </td>
              }
              <td class="center-align text-center">
                @if (isTemplate) {
                  <div class="status-badge"
                       [ngClass]="eventItem.leagueTemplateStatus != null ? templateStatusClassMap[eventItem.leagueTemplateStatus] : ''">
                    <span class="fw-bold">{{ t("league.template.event.status." + eventItem.leagueTemplateStatus) | uppercase }}</span>
                  </div>
                }
                @else {
                  <div class="status-badge"
                       [ngClass]="eventItem.status != null ? statusClassMap[eventItem.status] : ''">
                    <span class="fw-bold">{{ t("event.item.status." + eventItem.status) | uppercase }}</span>
                  </div>
                }
              </td>
              <td class="text-end center-align" [class.error]="eventItem.id ? !eventValidityMap.get(eventItem.id!) : false">
                {{ eventItem.start ?? '' | localizedDate:'short' }}
              </td>
              <td class="text-end center-align" [class.error]="eventItem.id ? !eventValidityMap.get(eventItem.id!) : false">
                {{ eventItem.end ?? '' | localizedDate:'short' }}
                @if (eventItem.id && !eventValidityMap.get(eventItem.id!) ) {
                  <i class="bi bi-info-circle info-icon ps-2 error"
                     ngbTooltip="{{ t('app.validation.error.league.event.dates') }}"
                     placement="left"></i>
                }
              </td>
              <td class="text-end center-align" (click)="$event.stopPropagation()">
                @if (!disableEditing && showDropdown) {
                  <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                    <span class="menu-icon" ngbDropdownToggle>
                      <i class="fas fa-ellipsis-v"></i>
                    </span>
                    <ul ngbDropdownMenu>
                      @if (showDetailsDropdownAction) {
                        <li ngbDropdownItem (click)="onDetailsClick(eventItem)">
                          {{ t("app.common.details") }}
                        </li>
                      }
                      @if (showChangeEventTypeDropdownAction) {
                        <li ngbDropdownItem (click)="onChangeTypeClick(eventItem)">
                          {{ t( "league.event.action.change.type.from." + eventItem.leagueEventType) }}
                        </li>
                      }
                     @if (showAddShortNameDropdownAction) {
                        <li ngbDropdownItem (click)="onOpenShortNameModal(eventItem)">
                            {{ t('event.item.add.name.short') }}
                        </li>
                     }
                      <li ngbDropdownItem (click)="onRemoveClick(eventItem.id!)">
                        {{ t("app.common.delete") }}
                      </li>
                    </ul>
                  </div>
                }
              </td>
            </tr>
            @if (expandedEventIds.has(eventItem!.id!) && showRaces) {
              @if (eventItem.racesList?.length) {
                @for (race of eventItem?.racesList; track race; let isLast = $last) {
                  <tr class="expanded-content-row" [class.is-last]="isLast" (click)="toggleEvent(eventItem!.id!)">
                    <td></td>
                    <td class="center-align">{{ race.id }}</td>
                    <td class="center-align">
                      <div class="ps-4 text-wrap">
                        <app-language-output
                          [hrLabel]="race.name"
                          [enLabel]="race.nameEng"
                          [itLabel]="race.nameIta"
                          [srLabel]="race.nameSr"
                          [bsLabel]="race.nameBs"
                          [siLabel]="race.nameSlo"
                          [defaultLanguage]="eventItem?.defaultLanguage"
                          [languages]="languages"/>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    @if (showOrganizerName) {
                      <td></td>
                    }
                    @if (showRound) {
                      <td></td>
                    }
                    @if (showType) {
                      <td></td>
                    }
                    <td class="text-end center-align">{{ race.raceStart ?? '' | localizedDate:'short' }}</td>
                    <td class="text-end center-align">{{ race.raceEnd ?? '' | localizedDate:'short' }}</td>
                    <td class="text-end center-align" (click)="$event.stopPropagation()">
                      @if (!disableEditing && showDropdown) {
                        <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                          <span class="menu-icon" ngbDropdownToggle>
                            <i class="fas fa-ellipsis-v"></i>
                          </span>
                          <ul ngbDropdownMenu>
                            <li ngbDropdownItem (click)="onRemoveClick(race.id!, true)">
                              {{ t("app.common.delete") }}
                            </li>
                          </ul>
                        </div>
                      }
                    </td>
                  </tr>
                }
              } @else {
                <tr class="expanded-content-row">
                  <td [attr.colspan]="showOrganizerName ? 7 : 6" class="p-0">
                    <div class="text-muted text-center py-3">{{ t('league.details.no.races') }}</div>
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>
  } @else {
    <div class="my-3">
      <app-empty-state-admin/>
    </div>
  }
</ng-container>
